import { render } from "./ShowPayment.vue?vue&type=template&id=10585062"
import script from "./ShowPayment.vue?vue&type=script&lang=js"
export * from "./ShowPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__